<template>
  <div class="mt-2">
    <ListCoop 
      v-if="busId" 
      :busId="busId"
    />
  </div>
</template>
<script>
  import ListCoop from '@/views/admin/products/coope/List';
  import { mapState } from 'vuex';
  export default {
    components: {
      ListCoop
    },
    data: () => ({
      busId: null,
    }),
    computed: {
      ...mapState([
        'authMod'
      ])
    },
    mounted () {
      let user = this.authMod.user.user;
      this.busId = parseInt(user.info.coso_id);
    }
  }
</script>